import React from 'react';
import { Typography, Button, Container, Card, CardContent } from '@mui/material';
import { Fade } from 'react-awesome-reveal';
import { Link } from 'react-router-dom';

const jobPostings = [
  {
    title: 'Full Stack Developer',
    description: 'We are looking for a Full Stack Developer to work on innovative solutions, using React and Node.js.',
    responsibilities: [
      'Develop both front-end and back-end applications.',
      'Collaborate with design and product teams to implement UI/UX designs.',
      'Maintain and improve code quality, organization, and automation.',
      'Optimize applications for speed and scalability.',
    ],
    qualifications: [
      'Proficiency with JavaScript frameworks like React and Node.js.',
      'Experience with databases such as MySQL, MongoDB, or PostgreSQL.',
      'Familiarity with AWS or other cloud services is a plus.',
      '3+ years of professional development experience.',
    ],
  },
  {
    title: 'UI/UX Designer',
    description: 'We are seeking a creative UI/UX Designer to create visually appealing and user-friendly interfaces.',
    responsibilities: [
      'Design intuitive user interfaces for web and mobile applications.',
      'Collaborate with developers and product managers to ensure designs are feasible.',
      'Conduct user research and create wireframes and prototypes.',
      'Stay updated on industry trends and best practices.',
    ],
    qualifications: [
      'Proficiency in design tools like Figma, Adobe XD, or Sketch.',
      'Experience in creating responsive designs for mobile and web.',
      'Strong understanding of UX principles and UI design patterns.',
      '2+ years of professional design experience.',
    ],
  },
];

const Careers = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 5 }}>
      <Fade triggerOnce>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 5 }}>
          Join Our Team
        </Typography>
      </Fade>

      {/* Loop through the jobPostings array to create multiple job postings */}
      {jobPostings.map((job, index) => (
        <Fade key={index} triggerOnce direction="up">
          <Card sx={{ mb: 4, borderRadius: '12px', boxShadow: 3 }}>
            <CardContent>
              <Typography variant="h4" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
                {job.title}
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {job.description}
              </Typography>

              {/* Responsibilities */}
              <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mt: 3 }}>
                Responsibilities:
              </Typography>
              <ul style={{ marginLeft: '20px' }}>
                {job.responsibilities.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>

              {/* Qualifications */}
              <Typography variant="h6" component="h3" sx={{ fontWeight: 'bold', mt: 3 }}>
                Qualifications:
              </Typography>
              <ul style={{ marginLeft: '20px' }}>
                {job.qualifications.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>

              {/* Apply Button */}
              <Button variant="contained" color="primary" sx={{ mt: 3 }} component={Link} to="/contact">
                Apply Now
              </Button>
            </CardContent>
          </Card>
        </Fade>
      ))}
    </Container>
  );
};

export default Careers;
